/**
 * Used to enable to disabled debug mode
 * @example
 * if(DEBUG){
 *  console.log("This text appears only when it's debug mode.");
 * }
 * @define {boolean} DEBUG
 */
var DEBUG = false;

/**
 * Main function. Entry point
 */
new ThreeJuly(document.documentElement);